import { LitElement } from '@lit'

class NovaProductGallery extends LitElement {
  constructor() {
    super()
    this._carouselObservers = []
  }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener('nova:product:render-gallery', this._handleGalleryRender)
    this._initCarousels()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener('nova:product:render-gallery', this._handleGalleryRender)
    this._disconnectCarouselObservers()
  }

  _handleGalleryRender = (event) => {
    this.updateGalleryContent(event.detail.html)
  }

  _disconnectCarouselObservers() {
    for (const observer of this._carouselObservers) {
      observer.disconnect()
    }
    this._carouselObservers = []
  }

  _syncCarouselNav(carousel) {
    const items = carousel.querySelectorAll('sl-carousel-item')
    const hideNav = items.length <= 1
    carousel.dataset.nav = hideNav ? 'hidden' : 'visible'
  }

  _watchCarouselNav(carousel) {
    const prev = carousel.shadowRoot?.querySelector(
      '.carousel__navigation-button--previous',
    )
    const next = carousel.shadowRoot?.querySelector(
      '.carousel__navigation-button--next',
    )

    if (!prev && !next) return

    const sync = () => this._syncCarouselNav(carousel)
    carousel.addEventListener('sl-slide-change', sync)

    const observer = new MutationObserver(sync)
    if (prev) {
      observer.observe(prev, {
        attributes: true,
        attributeFilter: ['class', 'disabled'],
      })
    }
    if (next) {
      observer.observe(next, {
        attributes: true,
        attributeFilter: ['class', 'disabled'],
      })
    }

    this._carouselObservers.push(observer)
    sync()
  }

  _initCarousels() {
    this._disconnectCarouselObservers()

    for (const carousel of this.querySelectorAll('.js-bento-carousel')) {
      carousel.goToSlide(0)
      this._watchCarouselNav(carousel)
    }
  }

  updateGalleryContent(content) {
    if (!content) return

    while (this.firstChild) {
      this.removeChild(this.firstChild)
    }

    while (content.firstChild) {
      this.appendChild(content.firstChild)
    }

    requestAnimationFrame(() => {
      this._initCarousels()
    })
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('nova-product-gallery', NovaProductGallery)
